export default __webpack_public_path__ + "static/mp-5a1cfea5e81ea4ceca013a9905b5193b.jpeg";